export default __webpack_public_path__ + "static/media/le_touquet15.ec04cfe1.jpg";